<template>
  <div class="app" id="app" :class="{ 'full-screen': fullScreen, 'width-screen': menus.length == 0 }">
    <nav-header v-show="!fullScreen"></nav-header>
    <div class="sidebar">
      <div class="sidebar-nav">
        <el-menu :default-active="activeIndex" router class="el-menu-vertical-demo" @select="handelMenu"
          :default-opends="opends">
          <div v-for="item in menus" :key="item.id">
            <el-menu-item :index="item.path" v-if="!item.children" :data="item.path">
              <i :class="item.iconCls" v-if="item.iconCls"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <el-submenu :index="item.path" v-if="item.children" :data="item.path">
              <template slot="title">
                <i :class="item.iconCls" v-if="item.iconCls"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item :index="sItem.path" v-for="sItem in item.children" :key="sItem.id" :data="item.path">
                <i :class="sItem.iconCls" v-if="sItem.iconCls"></i>
                <span slot="title">{{ sItem.name }}</span>
              </el-menu-item>
            </el-submenu>
          </div>
        </el-menu>
      </div>
    </div>
    <div class="main-content">
      <!-- <el-button type="default" icon="el-icon-arrow-left" v-if="$root.userInfo.token && !fullScreen" size="mini" @click="back" class="back">返回</el-button> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <nav-footer v-show="!fullScreen"></nav-footer>
    <el-dialog title="关注微信公众号" :visible.sync="$root.wxDialogVisible" width="600px" :close-on-click-modal="false">
      <div class="text-center">
        <p class="mb-10 font-15">扫码关注微信公众号，及时获取更多信息。</p>
        <div style="padding:10px">
          <img src="/static/img/wx_code.jpg" alt="" style="height:200px">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavHeader from "./components/shared/NavHeader.vue";
import NavFooter from "./components/shared/NavFooter.vue";
export default {
  name: "App",
  components: {
    NavHeader,
    NavFooter,
  },
  data() {
    return {
      fullScreen: true,
      activeIndex: "",
      opends: [],
      menus: [],
    };
  },
  //监听器
  watch: {
    $route(to, from) {
      //监听路由是否变化FV
      this.fullScreen = to.meta.fullScreen;
      let target = null;
      function setChildren(data) {
        data.map(item => {
          if (item.path == to.path) {
            target = item;
          }
          if (item.children && item.children.length > 0) {
            setChildren(item.children);
          }
        })
      }
      setChildren(this.menus);
      if (target) {
        this.activeIndex = to.path;
        this.func.setSession("activeIndex", this.activeIndex);
      } else {
        this.activeIndex = this.func.getSession("activeIndex") || to.path;
      }
    },
  },
  mounted() {
    this.init();
    // this.$bus.$on("Update_Sliders", (data, toPath) => {
    //   if (!data) {
    //     return
    //   }
    //   this.menus = data.children || [];
    //   for (let item of this.menus) {
    //     this.opends.push(item.path)
    //   }
    //   if (toPath) {
    //     let path = data.path;
    //     function getChildrenPath(target) {
    //       if (target.children && target.children.length > 0) {
    //         getChildrenPath(target.children[0]);
    //       } else {
    //         path = target.path;
    //       }
    //     }
    //     getChildrenPath(data);
    //     this.$router.push({ path });
    //   }
    // });
  },
  beforeDestroy() {
    this.$bus.$off('Update_Sliders')
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    init() {
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            this.$store.state,
            JSON.parse(sessionStorage.getItem("store"))
          )
        );
      }
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      if (browser.versions.trident) {
        window.attachEvent("beforeunload", () => {
          sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        });
      } else {
        window.addEventListener("beforeunload", () => {
          sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        });
      };
    },
    handelMenu(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.app {
  height: 100%;
  position: relative;
  background-color: #f0f0f0;

  .sidebar {
    width: 205px;
    position: absolute;
    top: 50px;
    bottom: 20px;
    left: 0px;
    overflow: auto;
    border: 1px solid #eee;
    border-width: 0 1px 0 0;
    z-index: 1;

    .sidebar-shortcuts {
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      background-color: #f5f5f5;
      height: 35px;
      padding: 7px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }

    .sidebar-nav {
      position: absolute;
      left: 20px;
      top: 15px;
      bottom: 15px;
      right: 0;
      overflow-y: auto;
      background-color: #fff;
      box-shadow: 0 0 10px 0 #eee;
      border-radius: 8px;

      .el-menu {
        border: none;
      }
    }
  }

  .main-content {
    position: absolute;
    top: 50px;
    bottom: 35px;
    left: 200px;
    right: 0;

    // overflow: auto;
    // background-color: #fff;
    .back {
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 2;
    }
  }

  &.width-screen {
    .sidebar {
      display: none;
    }

    .main-content {
      left: 0px;
    }
  }

  &.full-screen {
    .nav-header {
      display: none;
    }

    .footer {
      display: none;
    }

    .sidebar {
      display: none;
    }

    .main-content {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10;
    }
  }
}</style>


// WEBPACK FOOTER //
// src/pages/pc/App.vue